import React from 'react'

const Form = (props) => {
    return (
        <form onSubmit={props.onSubmit}>
            <div className="form-input" id="email">
                <label>Email Address</label>
                <input type="text" name="email" value={props.email} onChange={props.onChange} />
                <span className="error">{props.errors.email}</span>
            </div>
            <div className="actions">
                <button className={props.processing ? 'disabled' : ''}>Reset</button>
            </div>
        </form>
    )
}

export default Form